// eslint-disable-next-line import/prefer-default-export
export const headerColor = "var(--gold-400)"; // #e9e9e9
export const labelCategories = ["近隣倉庫", "センター倉庫"] as const;
export const areaData = [
  {
    area: "北海道",
    prefectures: [{ pref_name: "北海道", pref_cd: "01" }],
  },
  {
    area: "東北",
    prefectures: [
      { pref_name: "青森県", pref_cd: "02" },
      { pref_name: "岩手県", pref_cd: "03" },
      { pref_name: "宮城県", pref_cd: "04" },
      { pref_name: "秋田県", pref_cd: "05" },
      { pref_name: "山形県", pref_cd: "06" },
      { pref_name: "福島県", pref_cd: "07" },
    ],
  },
  {
    area: "関東",
    prefectures: [
      { pref_name: "茨城県", pref_cd: "08" },
      { pref_name: "栃木県", pref_cd: "09" },
      { pref_name: "群馬県", pref_cd: "10" },
      { pref_name: "埼玉県", pref_cd: "11" },
      { pref_name: "千葉県", pref_cd: "12" },
      { pref_name: "東京都", pref_cd: "13" },
      { pref_name: "神奈川県", pref_cd: "14" },
    ],
  },
  {
    area: "中部",
    prefectures: [
      { pref_name: "新潟県", pref_cd: "15" },
      { pref_name: "富山県", pref_cd: "16" },
      { pref_name: "石川県", pref_cd: "17" },
      { pref_name: "福井県", pref_cd: "18" },
      { pref_name: "山梨県", pref_cd: "19" },
      { pref_name: "長野県", pref_cd: "20" },
      { pref_name: "岐阜県", pref_cd: "21" },
      { pref_name: "静岡県", pref_cd: "22" },
      { pref_name: "愛知県", pref_cd: "23" },
    ],
  },
  {
    area: "近畿",
    prefectures: [
      { pref_name: "三重県", pref_cd: "24" },
      { pref_name: "滋賀県", pref_cd: "25" },
      { pref_name: "京都府", pref_cd: "26" },
      { pref_name: "大阪府", pref_cd: "27" },
      { pref_name: "兵庫県", pref_cd: "28" },
      { pref_name: "奈良県", pref_cd: "29" },
      { pref_name: "和歌山県", pref_cd: "30" },
    ],
  },
  {
    area: "中国",
    prefectures: [
      { pref_name: "鳥取県", pref_cd: "31" },
      { pref_name: "島根県", pref_cd: "32" },
      { pref_name: "岡山県", pref_cd: "33" },
      { pref_name: "広島県", pref_cd: "34" },
      { pref_name: "山口県", pref_cd: "35" },
    ],
  },
  {
    area: "四国",
    prefectures: [
      { pref_name: "徳島県", pref_cd: "36" },
      { pref_name: "香川県", pref_cd: "37" },
      { pref_name: "愛媛県", pref_cd: "38" },
      { pref_name: "高知県", pref_cd: "39" },
    ],
  },
  {
    area: "九州",
    prefectures: [
      { pref_name: "福岡県", pref_cd: "40" },
      { pref_name: "佐賀県", pref_cd: "41" },
      { pref_name: "長崎県", pref_cd: "42" },
      { pref_name: "熊本県", pref_cd: "43" },
      { pref_name: "大分県", pref_cd: "44" },
      { pref_name: "宮崎県", pref_cd: "45" },
      { pref_name: "鹿児島県", pref_cd: "46" },
      { pref_name: "沖縄県", pref_cd: "47" },
    ],
  },
];
